import jwtDecode from 'jwt-decode';
import axios from 'axios';

//import config from '../../config';
// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';
//axios.defaults.baseURL = "https://localhost:44385/api/v1";// "https://localhost:44385/api/v1"; "/api/v1"; "https://seejobapp.ir/api/v1"
//axios.defaults.baseURL = "https://seejobapp.ir/api/v1";// "https://localhost:44385/api/v1"; "/api/v1"; "https://seejobapp.ir/api/v1"
axios.defaults.baseURL = "/api/v1";// "https://localhost:44385/api/v1"; "/api/v1"; "https://seejobapp.ir/api/v1"

// intercepting to capture errors
axios.interceptors.response.use(
    (response: any) => {
        return response;
    },
    (error: any) => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        let message;        
        if (error && error.response && error.response.status === 404) {
            window.location.href = '/not-found';
        } else if (error && error.response && error.response.status === 403) {
            window.location.href = '/access-denied';
        }
        //  else if (error && error.response && error.response.status === 500) {
        //     window.location.href = '/error-500';
        // }
        else {
            switch (error.response.status) {
                case 401:
                    message = 'Invalid credentials';
                    break;
                case 403:
                    message = 'Access Forbidden';
                    break;
                case 404:
                    message = 'Sorry! the data you are looking for could not be found';
                    break;
                default: {
                    message =
                        error.response && error.response.data ? error.response.data['message'] : error.message || error;
                }
            }
            return Promise.reject(message);
        }
    }
);

const AUTH_SESSION_KEY = 'SeejobKarbar';

/**n
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: string | null) => {
    if (token) axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    else delete axios.defaults.headers.common['Authorization'];
};

const getUserFromCookie = () => {
    const user = sessionStorage.getItem(AUTH_SESSION_KEY);
    
    return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};

class APICore {
    /**
     * Fetches data from given url
     */
    get = (url: string, params: any) => {
        let response;
        // if (params) {
        //     var queryString = params
        //         ? Object.keys(params)
        //             .map((key) => key + '=' + params[key])
        //             .join('&')
        //         : '';
        //     response = axios.get(`${url}?${queryString}`, params);
        // } else {
        response = axios.get(`${url}`, params);
        // }
        return response;
    };

    createFile = (url: string, obj: any) => {
        


const d= axios.post(url, obj, { responseType: 'blob' }) 
return d
        // let response;
        // if (data)
        // response= axios.post(url, data, { responseType: 'blob' });
        // else
        // response = axios.post(url, { responseType: 'blob' });

        // return response;
    };

    getFile = (url: string, params: any) => {
        let response;
        if (params) {
            var queryString = params
                ? Object.keys(params)
                    .map((key) => key + '=' + params[key])
                    .join('&')
                : '';
            response = axios.get(`${url}?${queryString}`, { responseType: 'blob' });
        } else {
            response = axios.get(`${url}`, { responseType: 'blob' });
        }
        return response;
    };

    getFileForm = (url: string, data: any) => {
        

        let response;
        
            response = axios.get(`${url}`, {params:data, responseType: 'blob' });
        
        return response;
    };

    getMultiple = (urls: string, params: any) => {
        const reqs = [];
        let queryString = '';
        if (params) {
            queryString = params
                ? Object.keys(params)
                    .map((key) => key + '=' + params[key])
                    .join('&')
                : '';
        }

        for (const url of urls) {
            reqs.push(axios.get(`${url}?${queryString}`));
        }
        return axios.all(reqs);
    };

    /**
     * post given data to url
     */
    create = (url: string, data: any) => {
        return axios.post(url, data);
    };

    createLogin = async (url: string, data: any) => {
        var querystring = require("query-string");
        try {
            const s = await axios.post(url, querystring.stringify({
                "grant_type": "password",
                "username": data.email,
                "password": data.password,
                "code":data?.code ? data?.code: '',
                "refresh_token": '1',
                "scope": '1',
                "client_secret": '1',
                "client_id": '1'
            }), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;'
                }
            })
            return s
        }
        catch (e) {
            return { "message": 'نام کاربری یا رمز عبور اشتباه است' }
        }
        //return axios.post(url, data);
    };
    

    /**
     * Updates patch data
     */
    updatePatch = (url: string, data: any) => {
        return axios.patch(url, data);
    };

    /**
     * Updates data
     */
    update = (url: string, data: any) => {
        return axios.put(url, data);
    };

    /**
     * Deletes data
     */
    delete = (url: string) => {       
        return axios.delete(url);
    };

    deleteWithItem = (url: string, data: any) => {
        return axios.delete(url, { params: data });
    };

    /**
     * post given data to url with file
     */

    createUpload = (url: string, formData: any) => {


        const config = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.post(url, formData, config);
    };

    createWithFile = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.post(url, formData, config);
    };

    /**
     * post given data to url with file
     */
    updateWithFile = (url: string, data: any) => {
        const formData = new FormData();
        for (const k in data) {
            formData.append(k, data[k]);
        }

        const config = {
            headers: {
                ...axios.defaults.headers,
                'content-type': 'multipart/form-data',
            },
        };
        return axios.patch(url, formData, config);
    };

    isUserAuthenticated = () => {
        const user = this.getLoggedInUser();
        if (user === "") {
            return false;
        }
        // const decoded: any = jwtDecode(user);        

        const currentTime = Date.now() / 1000;
        if (user.exp < currentTime) {
            console.warn('access token expired');
            return false;
        } else {
            return true;
        }
    };

    isUserAllowed = (requiredScopes: any) => {
        let isAllowed = false;
        const user = this.getLoggedInUser();

        if (user === "") {
            isAllowed = false;;
        }

        if (requiredScopes) {

            if (requiredScopes.every((v: any) => user.Permission?.includes(`PERMISSIONS${v.toString().toUpperCase()}`))) {
                isAllowed = true;
            }
        }
        else {
            isAllowed = true;
        }
        return isAllowed;
    };

    setLoggedInUser = (session: any) => {
        if (session) sessionStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session));
        else {
            sessionStorage.removeItem(AUTH_SESSION_KEY);
        }
    };
    /**
     * Returns the logged in user
     */
    getLoggedInUser = () => {
        let token = getUserFromCookie();        
        if (!token) {
            return "";
        }
        const decoded: any = jwtDecode(token);
        return decoded;
    };

    getLoggedInUserFromCookie = () => {
        let token = getUserFromCookie();        
        if (!token) {
            return "";
        }
        
        return token;
    };

    setUserInSession = (modifiedUser: any) => {
        let userInfo = sessionStorage.getItem(AUTH_SESSION_KEY);
        if (userInfo) {
            const { token, user } = JSON.parse(userInfo);
            this.setLoggedInUser({ token, ...user, ...modifiedUser });
        }
    };
}

/*
Check if token available in session
*/
let token = getUserFromCookie();
if (token) {
    setAuthorization(token);
}

export { APICore, setAuthorization };
